module.exports = __webpack_public_path__ + "img/horizontal_1_1_6005.73a69e63.png";